import script from "./logo.vue?vue&type=script&lang=ts&setup=true"
export * from "./logo.vue?vue&type=script&lang=ts&setup=true"

import "./logo.vue?vue&type=style&index=0&id=3dfe8cf2&lang=scss&scoped=true"
import "./logo.vue?vue&type=style&index=1&id=3dfe8cf2&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dfe8cf2"]])

export default __exports__